import React, { useEffect, useState } from 'react';
import {
  Testimonial,
  TestimonialsWrapper,
  TestimonialImage,
  TestimonialName,
  TestimonialTitle,
  TestimonialsBody
} from './styled.components';
import { StyledBtn } from '../global/buttons/styled.components';
import { useTranslation } from 'react-i18next';

function Testimonials({ content }) {
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState(1);
  const [showMoreVisibility, setShowMoreVisibility] = useState(true);

  const itemsPerPage = 8;
  const endIndex = itemsPerPage * currentPage;
  const totalPages = Math.ceil(content.length / itemsPerPage);
  let contentShownCurrently = content.slice(0, endIndex);

  useEffect(() => {
    if (content.length < itemsPerPage) setShowMoreVisibility('hide');
  }, [content]);

  function loadMoreTestimonials() {
    switch (true) {
      case currentPage < totalPages:
        setShowMoreVisibility(true);
        setCurrentPage((currentPage) => currentPage + 1);
        break;
      case currentPage === totalPages:
        setShowMoreVisibility(false);
      default:
        break;
    }
  }
  function goToFirstPage() {
    setCurrentPage(1);
    setShowMoreVisibility(true);
  }

  return (
    <TestimonialsWrapper>
      <TestimonialsBody>
        {contentShownCurrently.map((testimonial, index) => {
          return (
            <Testimonial key={index}>
              <TestimonialImage
                src={testimonial.image}
                alt={testimonial.name + ' ' + testimonial.title}
              />
              <TestimonialName>{testimonial.name}</TestimonialName>
              <TestimonialTitle>{testimonial.title}</TestimonialTitle>
            </Testimonial>
          );
        })}
      </TestimonialsBody>
      {!showMoreVisibility ? (
        <StyledBtn onClick={() => goToFirstPage()}>{t('hide')}</StyledBtn>
      ) : showMoreVisibility === true ? (
        <StyledBtn onClick={() => loadMoreTestimonials()}>
          {t('show_more')}
        </StyledBtn>
      ) : null}
    </TestimonialsWrapper>
  );
}

export default Testimonials;
